
<div class="row">
  <div class="col-2 offset-5">
    <div class="card">
      <article class="card-body">
        <h4 class="card-title text-center mb-4 mt-1">Ameritrade Sign In</h4>
        <hr>
       <button class="btn btn-primary w-100" (click)="signIn()">Sign in to Ameritrade</button>
      </article>
    </div>
  </div>
</div>
